import{m as u}from"./chunk-HBP5N4FR.js";u();function n(t){return{if:function(e){return e?{then:p=>p instanceof Function?n(p(t)):n(p)}:{then:()=>n(t)}},then:e=>e instanceof Function?n(e(t)):n(e),valueOf:function(){return t}}}export{n as a};
//# sourceMappingURL=chunk-DQG5M55E.js.map
